import React from 'react';
import {InputLabel, MenuItem, OutlinedInput, Paper, Select, TextField, FormControl, Button} from '@material-ui/core'
import {LookupParams} from "../App";
import {RecordType} from "../App"

interface FilterFieldsProps {
    queryParams: any;
    applyFilter: (filterFields: LookupParams | undefined) => void;
    currentFilter: LookupParams | undefined;
    handleClosePopover: () => void;
}


export default function FilterFields(props: FilterFieldsProps) {
    const { queryParams, applyFilter, currentFilter, handleClosePopover} = props;

    // @ts-ignore
    const hosts = [...new Set(queryParams.map((obj: LookupParams) => obj.host))]
    // @ts-ignore
    const types = [...new Set(queryParams.map((obj: LookupParams) => obj.type))]
    // @ts-ignore
    const nameServers = [...new Set(queryParams.map((obj: LookupParams) => obj.nameServer))]
    // @ts-ignore
    const locations = [...new Set(queryParams.map((obj: LookupParams) => obj.location))]
    const [filter, setFilter] = React.useState<LookupParams>(!!currentFilter ? currentFilter : {
        host: '',
        type: '',
        nameServer: '',
        location: '',
    })
    const inputLabel = React.useRef(null);
    const [applyDisabled, setApplyDisabled] = React.useState(true)

    // Sets "Apply" button to disabled if there are no filters selected
    React.useEffect(() => {
        const {host, type, nameServer, location} = filter;

        if (host.length <= 0 && type.length <= 0 && nameServer.length <= 0 && location.length <= 0) {
           setApplyDisabled(true)
        } else {
            setApplyDisabled(false)
        }
    })


    function handleChangeDomain(val: string) {
        const tempFilter = {...filter, host: val}
        setFilter(tempFilter)
    }

    function handleChangeType(val: RecordType) {
        const tempFilter = {...filter, type: val}
        setFilter(tempFilter)
    }

    function handleChangeResolver(val: string) {
        const tempFilter = {...filter, nameServer: val}
        setFilter(tempFilter)
    }

    function handleChangeLocation(val: string) {
        const tempFilter = {...filter, location: val.slice(0,4).toUpperCase()}
        setFilter(tempFilter)
    }

    function handleApplyFilter(filter: LookupParams) {
        console.log(filter)
        applyFilter(filter)
        handleClosePopover()
    }

    function handleClearFilter() {
        applyFilter(undefined)
        setFilter({
            host: '',
            type: '',
            nameServer: '',
            location: '',
        })
    }


    return (
        <Paper style={{display: 'flex', flexDirection: 'column', padding: "20px"}}>
            <div style={{display: 'flex', alignItems: 'flex-end', marginBottom: '20px'}}>
                <FormControl style={{marginRight: '20px'}}>
                    <InputLabel
                        ref={inputLabel}
                        id="demo-simple-select-outlined-label"
                        shrink
                    >Domain Name</InputLabel>
                    <Select
                        style={{marginRight: '0', width: '200px'}}
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={filter.host}
                        onChange={(event: any) => handleChangeDomain(event.target.value)}
                        label="Age"
                    >
                        {queryParams.length > 0 ? hosts.map((host: string, index: number) => {
                            return <MenuItem key={index} value={host}>{host}</MenuItem>
                        }) : <MenuItem value={0}>No Checks have been run</MenuItem>}
                    </Select>
                </FormControl>
                <FormControl>
                    <InputLabel
                        ref={inputLabel}
                        id="demo-simple-select-outlined-label"
                        shrink
                    >Record Type</InputLabel>
                        {queryParams.length > 0 ? (
                            <Select
                                value={filter.type}
                                style={{marginRight: '10px', width: '110px'}}
                                label="Record Type"
                                onChange={(event: any) => handleChangeType(event.target.value)}
                            >
                            <MenuItem value="">None</MenuItem>
                            {types.map((type: string, index: number) => {
                            return <MenuItem key={index} value={type}>{type}</MenuItem>
                        })}
                            </Select>
                        ) : (
                            <Select
                                value={filter.type}
                                style={{marginRight: '10px', width: '110px'}}
                                label="Record Type"
                                onChange={(event: any) => handleChangeType(event.target.value)}
                            >
                            <MenuItem value={0}>No Checks have been run</MenuItem>
                            </Select>
                        )}
                </FormControl>

            </div>
            <div style={{display: 'flex', alignItems: 'flex-end'}}>
                <FormControl style={{marginRight: '20px'}}>
                    <InputLabel
                        ref={inputLabel}
                        id="demo-simple-select-outlined-label"
                        shrink
                    >Resolver</InputLabel>
                    <Select
                        style={{marginRight: '0', width: '200px'}}
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={filter.nameServer}
                        onChange={(event: any) => handleChangeResolver(event.target.value)}
                        label="Age"
                    >
                        {queryParams.length > 0 ? nameServers.map((nameserver: string, index: number) => {
                            return <MenuItem key={index} value={nameserver}>{nameserver}</MenuItem>
                        }) : <MenuItem value={0}>No Checks have been run</MenuItem>}
                    </Select>
                </FormControl>
                <FormControl>
                    <InputLabel
                        ref={inputLabel}
                        id="demo-simple-select-outlined-label"
                        shrink
                    >Location</InputLabel>
                    <Select
                        style={{marginRight: '0', width: '200px'}}
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={filter.location}
                        onChange={(event: any) => handleChangeLocation(event.target.value)}
                        label="Age"
                    >
                        {queryParams.length > 0 ?  locations.map((location: string, index: number) => {
                            return <MenuItem key={index} value={location.slice(0,4).toUpperCase()}>{location.slice(0,4).toUpperCase()}</MenuItem>
                        }) : <MenuItem value={0}>No Checks have been run</MenuItem>}
                    </Select>
                </FormControl>
            </div>
            <div style={{alignSelf: 'flex-end'}}>
                <Button
                    disabled={applyDisabled}
                    style={{maxWidth: '90px', margin: '20px 20px 0 0'}}
                    size='small'
                    variant="contained"
                    color="primary"
                    onClick={() => handleApplyFilter(filter)}
                >
                    Apply
                </Button>
                <Button
                    style={{maxWidth: '90px', marginTop: '20px', alignSelf: 'flex-end'}}
                    size='small'
                    variant="contained"
                    color="primary"
                    onClick={() => handleClearFilter()}
                >
                    Clear
                </Button>
            </div>
        </Paper>
    )
}